import React, { useContext } from 'react'
import { useQuery } from '@apollo/client'
import { Grid, Transition } from 'semantic-ui-react'

import { AuthContext } from '../context/auth'

import PostCard from '../components/PostCard'
import PostForm from '../components/PostForm'
import { FETCH_POSTS_QUERY } from '../util/graphql'

function Home() {
    const { user } = useContext(AuthContext);
    const { loading, data } = useQuery(FETCH_POSTS_QUERY);

    return (
        <Grid columns={1} >
            <Grid.Row className='page-title' >
                <h1> Recent Posts </h1>
            </Grid.Row>
            <Grid.Row > {
                user && (<Grid.Column style={{ marginBottom: 20 }}>
                    <PostForm />
                </Grid.Column>)
            } {loading ? (<h1> Loading posts.. </h1>) : (<Transition.Group > {data.getPosts && data.getPosts.map((posts) =>
            (<Grid.Column key={posts.id} style={{ marginBottom: 20 }}>
                <PostCard post={posts} />
            </Grid.Column>)
            )
            } </Transition.Group>)
                }
            </Grid.Row>
        </Grid>
    );
}

export default Home;